<style lang="css" scoped>

.job-item {
    cursor: pointer;
}

.job-item:hover {
    background: #3333;
}

.main {
    width: 100%;
    height: 100% !important;
}

</style>

<template>

<div class="main card" id="">
    <div class="card-header">
        Reschedule Requests
    </div>
    <div class="card-body">
        <b-card style="margin-top:8px" v-for="job in jobs" @click="showModal(job)" :sub-title="job.job_id" class="job-item" :title="job.user.username">
            <b-card-text>
                <b-row>
                    <b-col>
                        <span class="text-info" style="margin-right:2%">Schedule Date: </span>{{getReadableDate(job.createDate)}}
                    </b-col>
                    <b-col>
                        <span class="text-info">Start Time:</span> {{getReadableTime(job.from)}}
                    </b-col>
                    <b-col>
                        <span class="text-info">End Time:</span> {{getReadableTime(job.to)}}
                    </b-col>
                    <b-col cols="2"></b-col>
                </b-row>
            </b-card-text>

            <b-card-text>
                {{job.address}}
            </b-card-text>

            <b-card-text>
                {{job.reschedule_msg}}
            </b-card-text>
        </b-card>

    </div>

    <v-dialog v-model="details" transition="dialog-bottom-transition" fullscreen>
        <v-card fill-height>
            <v-toolbar dark dense disabled color="primary">
                <v-btn icon dark @click="hide">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Reschedule Job</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>

            <v-container>
                <v-row>
                    <v-col cols="12">
                        <v-row style="height: 60px;">
                            <v-col cols="2" class="text-info">
                                Customer Details:
                            </v-col>
                            <v-col cols="4">
                                <v-text-field v-model="job.customer.fname" dense disabled filled color="purple darken-2" label="First Name:">
                                </v-text-field>
                            </v-col>
                            <v-col cols="1"></v-col>
                            <v-col cols="4">
                                <v-text-field v-model="job.customer.lname" dense disabled filled color="purple darken-2" label="Last Name:" /> </v-col>
                        </v-row>
                        <v-row style="height: 60px;">
                            <v-col cols="2" class="text-info">
                            </v-col>
                            <v-col cols="4">
                                <v-text-field v-model="job.customer.phone" dense disabled filled color="purple darken-2" label="Phone:">
                                </v-text-field>
                            </v-col>
                            <v-col cols="1"></v-col>
                            <v-col cols="4">
                                <v-text-field v-model="job.customer.email" dense disabled filled color="purple darken-2" label="Email:">
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row style="height: 60px;">
                            <v-col cols="2" class="text-info">
                            </v-col>

                            <v-col cols="5">
                                <div>
                                    <small class="text-info">Owner of vehicle:</small>
                                    <v-switch class="shrink mr-0 mt-0" disabled v-model="job.customer.owner"></v-switch>
                                </div>

                            </v-col>
                            <v-col cols="5">

                            </v-col>
                        </v-row>

                        <v-divider></v-divider>

                        <v-row style="height: 65px;">
                            <v-col cols="2" class="text-info">
                                Job Details:
                            </v-col>
                            <v-col cols="4">
                                <v-text-field v-model="job.jobID" dense filled disabled color="purple darken-2" label="Job ID:" />
                            </v-col>
                            <v-col cols="1"></v-col>
                            <v-col cols="4">
                                <v-text-field v-model="job.status" dense filled disabled color="purple darken-2" label="Status:" />
                            </v-col>
                        </v-row>

                        <v-row v-for="type in job.jobTypes" style="height: 65px;">
                            <v-col cols="2"></v-col>
                            <v-col cols="2">
                                <v-text-field v-model="type.jobType" dense filled disabled color="purple darken-2" label="Job Type:" />
                            </v-col>
                            <v-col cols="2">
                                <v-text-field v-model="'$'+type.quote" dense disabled filled color="purple darken-2" label="Quote:">
                                </v-text-field>
                            </v-col>
                            <v-col cols="1"></v-col>
                            <v-col cols="4">
                                <small class="text-info">Selected Vehicle:</small>
                                <div>
                                    <v-chip class="ma-1" color="primary" text-color="white">
                                        Make: {{job.vehicle.key.make}}
                                    </v-chip>
                                    <v-chip class="ma-1" color="primary" text-color="white">
                                        Model: {{job.vehicle.key.model}}
                                    </v-chip>
                                    <v-chip class="ma-1" color="primary" text-color="white">
                                        Year: {{job.vehicle.key.year}}
                                    </v-chip>
                                </div>
                            </v-col>
                        </v-row>
                        <v-divider></v-divider>

                        <v-row v-for="type in job.jobTypes" v-if="type.jobType.includes('KEY')" style="height: 75px;">
                            <v-col cols="2" class="text-info">
                                Location/Key:
                            </v-col>
                            <v-col cols="4">
                                <v-select v-model="locSelect" :item-value="item => item.id" :item-text="item => item.name" @input="changeLocation" :items="locations" filled label="Location:">
                                </v-select>
                            </v-col>
                            <v-col cols="1"></v-col>
                            <v-col cols="4">
                                <v-autocomplete v-if="locSelect" v-model="key" :item-value="item => item" :filter="filterKeys" :items="keys" filled label="Available Keys:">
                                    <v-list-tile name="ava2" class="pa-2" slot="item" slot-scope="{item}">
                                        <v-avatar left>
                                            <v-img v-bind:src="item.key.image"></v-img>
                                        </v-avatar>
                                        {{item.key.oem}}
                                    </v-list-tile>
                                    <v-list-tile name="ava3" class="pa-2" slot="selection" slot-scope="{item}">
                                        <v-avatar left>
                                            <v-img v-bind:src="item.key.image"></v-img>
                                        </v-avatar>
                                        {{item.key.oem}}
                                    </v-list-tile>
                                </v-autocomplete>
                            </v-col>
                        </v-row>

                        <v-row v-for="type in job.jobTypes" v-if="type.jobType.includes('KEY')" style="min-height: 70px;">
                            <v-col cols="2"></v-col>
                            <v-col cols="7">
                                <small v-if="key != null && key.stock" class="text-info">Selected Key: (Stock: <span class="text-success">{{key.stock}}</span> Price: <span class="text-success">{{key.price}}</span> )</small>
                                <small v-else class="text-info">Selected Key:</small>

                                <div v-if="key != null">
                                    <v-avatar left>
                                        <v-img v-bind:src="key.key.image"></v-img>
                                    </v-avatar>
                                    <v-chip class="ma-1" color="green" text-color="white">
                                        OEM: {{key.key.oem}}
                                    </v-chip>
                                    <v-chip class="ma-1" color="green" text-color="white">
                                        FCC: {{key.key.fcc}}
                                    </v-chip>
                                    <v-chip class="ma-1" color="green" text-color="white">
                                        IC: {{key.key.ic}}
                                    </v-chip>
                                </div>
                            </v-col>
                        </v-row>

                        <v-divider v-for="type in job.jobTypes" v-if="type.jobType.includes('KEY')"></v-divider>

                        <v-row style="height: 65px;">
                            <v-col cols="2" class="text-info">
                                Time/Technician:
                            </v-col>
                            <v-col cols="4">
                                <v-menu ref="menu" v-model="menu" :close-on-content-click="false" :return-value.sync="request.date" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-model="request.date" label="Date" prepend-inner-icon="event" readonly v-bind="attrs" v-on="on" filled></v-text-field>
                                    </template>
                                    <v-date-picker v-model="request.date" no-title scrollable :show-current="true">
                                        <v-spacer></v-spacer>
                                        <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                                        <v-btn text color="primary" @click="$refs.menu.save(request.date)">OK</v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="1"></v-col>
                            <v-col cols="4">
                                <v-select v-model="userSelect" @input="changeUser" :item-value="item => item.email" :item-text="item => item.username" :items="users" filled label="Technician:"></v-select>
                            </v-col>
                        </v-row>

                        <v-row style="height: 65px;">
                            <v-col cols="2" class="text-info">

                            </v-col>
                            <v-col cols="2">
                                <v-select v-model="request.from" :items="hours" filled label="Start Time:"></v-select>
                            </v-col>
                            <v-col cols="2">
                                <v-select v-model="request.to" :items="hours" filled label="End Time:"></v-select>
                            </v-col>
                            <v-col cols="1"></v-col>
                            <v-col cols="2">
                                <small v-if="timeInfoStatus" class="text-success">{{timeInfo}}</small>
                                <small v-else class="text-danger">{{timeInfo}}</small>
                            </v-col>
                            <v-col cols="1">
                                <v-btn color="primary" small @click="checkAvailability">Check Availability</v-btn>
                            </v-col>

                        </v-row>
                        <v-row style="height: 60px;">
                            <v-col cols="2" class="text-info">
                            </v-col>
                            <v-col cols="4">
                                <v-text-field v-model="job.address" dense filled color="purple darken-2" label="Address:">
                                </v-text-field>
                            </v-col>
                            <v-col cols="1"></v-col>
                            <v-col cols="4">
                                <v-text-field v-model="job.opRemarks" dense disabled filled color="purple darken-2" label="Remarks:" />
                            </v-col>
                        </v-row>
                        <v-row style="margin-top:2%">
                            <v-col cols="4" class="text-info">
                            </v-col>
                            <v-col cols="3">
                                <v-btn color="success" @click="save">Submit</v-btn>
                            </v-col>
                            <v-col cols="3">
                                <v-btn color="error" @click="hide">Cancel</v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</div>

</template>

<script>

import Utils from './kalendar/utils.js'
export default {
    created() {
            this.$api.getRescheduledJobs().then(res => {
                if (res.status == 200) {
                    this.jobs = res.data
                }
            })
            this.locations = this.$store.state.locations
        },
        data: () => ({
            jobs: [],
            users: [],
            keys: [],
            locations: [],
            hours: [
                '05:00 AM',
                '06:00 AM',
                '07:00 AM',
                '08:00 AM',
                '09:00 AM',
                '10:00 AM',
                '11:00 AM',
                '12:00 PM',
                '01:00 PM',
                '02:00 PM',
                '03:00 PM',
                '04:00 PM',
                '05:00 PM',
                '06:00 PM',
                '07:00 PM',
                '08:00 PM',
                '09:00 PM',
                '10:00 PM',
                '11:00 PM',
                '00:00 PM'
            ],
            job: {
                customer: {
                    phone: null,
                    fname: null,
                    lname: null,
                    caa_card: null,
                    company: null,
                    channel: null,
                    email: null
                },
                from: null,
                to: null,
                date: null,
                jobType: null,
                address: null,
                quote: null,
                opRemarks: null,
                user: null,
                oem: null,
                make: null,
                model: null,
                year: null
            },
            timeInfo: '',
            menu: false,
            timeInfoStatus: false,
            locSelect: null,
            userSelect: null,
            key: null,
            details: false,
            request: {
                to: '',
                from: '',
            }
        }),
        methods: {
            getReadableDate(date) {
                    var options = {
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric'
                    }
                    return new Date(date).toLocaleDateString('en-US', options)
                },
                getReadableDateNumeric(d) {
                    var date = new Date(d);
                    var year = date.getFullYear();
                    var month = ('0' + (date.getMonth() + 1)).slice(-2);
                    var day = ('0' + date.getDate()).slice(-2);

                    let temp = `${year}-${month}-${day}`;
                    return temp;
                },
                getReadableTime(date) {
                    let d = new Date(date).toUTCString()
                    let hours = d.substring(17, 19)
                    let minutes = d.substring(20, 22)
                    return this.formatAMPM(hours, minutes);
                },
                formatAMPM(hours, minutes) {
                    var ampm = hours >= 12 ? 'PM' : 'AM'
                    hours = hours % 12
                    hours = hours ? hours : 12
                    if (hours < 10) {
                        hours = '0' + hours;
                    }
                    var strTime = hours + ':' + minutes + ' ' + ampm

                    return strTime
                },
                changeUser(val) {
                    this.userSelect = val;
                },
                getDateFromString(s) {
                    let hour = Number(s.substring(0, 2))
                    let d = new Date(this.job.date)
                    d.setHours(hour)
                    return d
                },
                checkAvailability() {
                    if (this.request.date == null) {
                        this.timeInfo = 'Please select a date'
                        this.timeInfoStatus = false
                        return
                    }

                    if (this.userSelect == null) {
                        this.timeInfo = 'Please select a technician'
                        this.timeInfoStatus = false
                        return
                    }

                    if (this.request.to == null || this.request.from == null) {
                        this.timeInfo = 'Invalid Start/End Time'
                        this.timeInfoStatus = false
                        return
                    }

                    let to = this.getTwentyFourHourTime(this.request.to)
                    let from = this.getTwentyFourHourTime(this.request.from)

                    if (from >= to) {
                        this.timeInfo = 'Invalid Start/End Time'
                        this.timeInfoStatus = false
                        return
                    }

                    console.log(this.request.date);

                    this.$api
                        .checkAvailability(this.userSelect,
                           this.request.to,
                            this.request.from,
                            this.request.date)
                        .then(res => {
                            if (res.status == 200) {
                                let x = res.data
                                if (x == 0) {
                                    this.timeInfo = 'Technician is available'
                                    this.timeInfoStatus = true
                                } else {
                                    this.timeInfo = 'Technician is not available'
                                    this.timeInfoStatus = false
                                }
                            }
                        })
                },
                buildRequest(job) {
                    this.request.to = this.getReadableTime(job.to)
                    this.request.from = this.getReadableTime(job.from)
                    this.request.date = this.getReadableDateNumeric(job.date)

                    if(job.jobTypes.length > 0)
                    if (job.jobTypes[0].jobType.includes('KEY')) {
                        this.key = job.jobTypes[0].keyLocation;
                    } else {
                        this.getAllTechnicians(null);
                    }

                },
                getTwentyFourHourTime(amPmString) {
                    var d = new Date("1/1/2013 " + amPmString);
                    return d.getHours();
                },
                getAllTechnicians(id) {
                    this.$api.getAllTechnicians(id).then(res => {
                        if (res.status == 200) {
                            this.users = res.data;
                            this.userSelect = this.job.user.email;
                        }
                    })
                },
                changeLocation(val) {
                    this.getAllTechnicians(val);
                    this.key = null;
                    this.users = [];
                    this.keys = [];
                    this.userSelect = null;
                    this.$api.getPriceAndStock(this.job.vehicle.key.make, this.job.vehicle.key.model, this.job.vehicle.key.year, val)
                        .then(res => {
                            if (res.status == 200) {
                                this.keys = res.data
                            }
                        })
                        .catch(err => {
                            this.$toasted.error('Error Fetching details').goAway(1200)
                        })

                },
                keyChange(val) {
                    if (val != null)
                        this.key = val;

                },
                filterKeys(item, query, text) {
                    let key = item.key;
                    return (key.oem.toLocaleLowerCase().indexOf(query.toLocaleLowerCase()) > -1 || key.fcc.toLocaleLowerCase().indexOf(query.toLocaleLowerCase()) > -1 || key.ic.toLocaleLowerCase().indexOf(query.toLocaleLowerCase()) > -1);
                },
                showModal(job) {
                    this.job = job;
                    this.buildRequest(job);
                    this.details = true;
                },
                hide() {
                    this.keys = [];
                    this.key = null;
                    this.userSelect = null;
                    this.users = [];
                    this.locSelect = null;
                    this.details = false;
                },
                save() {
                    if (!this.timeInfoStatus) {
                        this.$toasted.error('Make sure technician is available').goAway(1200)
                        return
                    }
                    if (this.job.jobTypes[0].jobType.includes('KEY')) {
                        if (this.locSelect == null) {
                            this.$toasted.error('Select a location').goAway(2500);
                            return;
                        }
                        if (this.key == null) {
                            this.$toasted.error('Select a key').goAway(2500);
                            return;
                        }
                    }
                    let request = new Date(new Date(this.request.date).toLocaleString('en-US', { timeZone: 'America/Toronto' }));
                    let date = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Toronto' }));


                    if (this.timeInfoStatus) {
                        if (this.job.jobTypes[0].jobType.includes("KEY")) {
                            this.request.oem = this.key.key.oem;
                            this.request.loc = this.locSelect;
                        }
                        this.request.id = this.job.id
                        this.request.address = this.job.address
                        this.$overlay.show(this)

                         this.$api.rescheduleJob(this.request).then(res => {
                            if (res.status == 200) {
                                this.hide();
                                this.$api.getRescheduledJobs().then(res => {
                                    if (res.status == 200) {
                                        this.jobs = res.data
                                    }
                                })
                            }

                            this.$overlay.hide()
                        })

                    }
                }
        }
}

</script>
